import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const Btn = styled.button`
  display: block;
  width: 100%;
  padding: 16px;
  margin-top: 24px;
  background: var(--button-primary-color, #1D1D1F);
  color: #FFFFFF;
  border: 0;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0;
  cursor: pointer;
  &:disabled { opacity: 0.4; cursor: not-allowed; }
`;

export default function FinalizeButton({ disabled, loading, onClick, label }) {
  return (
    <Btn type="button" disabled={disabled || loading} onClick={onClick}>
      {loading ? "FINALIZANDO..." : label}
    </Btn>
  );
}

FinalizeButton.propTypes = {
  disabled: PropTypes.bool.isRequired,
  loading: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string,
};

FinalizeButton.defaultProps = {
  label: "FINALIZAR PAGAMENTO",
};
